import React, { useContext, useEffect, useState } from 'react'
import { Routes, Route, useLocation } from "react-router-dom";
import { trackEvent } from '../Helper/mixpanel';
import EachUserWrapper from '../Content/Users/EachUserWrapper';
import Login from '../Content/AuthPages/Login';
import BookingDetails from '../Content/Bookings/BookingDetails';
import CurrentSessions from '../Content/Bookings/CurrentSessions';
import FeedbackHome from '../Content/Feedback/FeedbackHome';
import AddNewMember from '../Content/Membership/AddNewMember';
import AllMembers from '../Content/Membership/AllMembers';
import CardDetails from '../Content/Membership/CardDetails';
import Home from '../Content/Pages/Home';
import ManageServices from '../Content/Services/ManageServices';
import ActiveSessions from '../Content/Sessions/ActiveSessions';
import Users from '../Content/Users/Users';
import AuthContext from '../store/auth-context';
import Ledger from '../Content/StoreLedger/Ledger';
import ManageStaff from '../Content/StaffManagement/ManageStaff';
import MonthlyRevenue from '../Content/Analytics/MonthlyRevenue';
import MusicPlayer from '../Content/Music/MusicPlayer';
import ConfigMembershipCards from '../Content/Membership/ConfigMembershipCards';
import Overview from '../Content/Dashboard/Overview';
import LeftMenu from '../Components/Menu/LeftMenu';
import styles from './MainNavigator.module.css'
import UpperHeader from '../Components/Menu/UpperHeader';
import AllStores from '../Content/Stores/AllStores';
import StoreDetails from '../Content/Stores/StoreDetails';
import StoreEmployees from '../Content/Stores/StoreEmployees';
import StorePriceList from '../Content/Stores/StorePriceList';
import StorePriceListBulkAction from '../Content/Stores/StorePriceListBulkAction';
import StoreClients from '../Content/Stores/StoreClients';
import NotFound from '../Content/404/NotFound';
import AddClients from '../Content/Users/AddClients';
import EventCalendar from '../Content/Calendar/EventCalendar';
import NetworkStatus from '../Components/UI/NetworkStatus';
import ManageEachEmployee from '../Content/StaffManagement/ManageEachEmployee';
import ManageAccess from '../Content/StaffManagement/ManageAccess';
import AllInvoices from '../Content/Invoices/AllInvoices';
import CofAlpha from '../Content/ClientOnboardingForm/CofAlpha';
import ManageUserRegistrationPages from '../Content/ClientOnboardingForm/ManageUserRegistrationPages';
import UpdateService from '../Components/Services/UpdateService';
import CollectionReport from '../Content/Dashboard/CollectionReport';
import ExpensesReport from '../Content/Dashboard/ExpensesReport';
import PriceListSettings from '../Content/Settings/PriceListSettings';
import OutstandingReport from '../Content/Dashboard/OutstandingReport';

import SendPromo from '../Content/Communications/SendPromo';
import ViewPromo from '../Content/Communications/ViewPromo';
import ActiveStoreContext from '../store/ActiveStoreContext';
import ComHome from '../Content/Communications/ComHome';
import ComAllCampaigns from '../Content/Communications/ComAllCampaigns';
import ComCreateCampaigns from '../Content/Communications/ComCreateCampaigns';
import CreateAudience from '../Content/Communications/CreateAudience';
import { ToastContainer } from 'react-toastify';
import GIInterfaceAlpha from '../Content/Invoices/GenerateInvoice/GIInterfaceAlpha';
import InvoicePreviewer from '../Content/Invoices/PreviewInvoice/InvoicePreviewer';
import UploadClientDataInBulk from '../Content/ClientUploading/UploadClientDataInBulk';
import ComAllAudiences from '../Content/Communications/ComAllAudiences';
import StaffAppointmentCalendar from '../Content/Calendar/StaffAppointmentCalendar';
import ManageStaffSummary from '../Content/StaffManagement/ManageStaffSummary';
import FeedbackSettings from '../Content/Feedback/FeedbackSettings';
import AccountSetup from '../Content/Settings/AccountSetup';
import StorePrimaryDetails from '../Content/Settings/StorePrimaryDetails';
import DailyReportsConfiguration from '../Content/Settings/DailyReports/DailyReportsConfiguration';
import DRDashboard from '../Content/Settings/DailyReports/DRDashboard';
import DRSettings from '../Content/Settings/DailyReports/DRSettings';
import DRHistory from '../Content/Settings/DailyReports/DRHistory';
import AccountSetting from '../Content/Settings/AccountSetting';
import ExpenseSetting from '../Content/Expenses/ExpenseSetting';
import LbHome from '../Content/LeadBridge/LbHome';
import LbGetStarted from '../Content/LeadBridge/LbGetStarted';
import LbGsHero from '../Components/LeadBridge/LbGsHero';
import LbDashboard from '../Content/LeadBridge/LbDashboard';
import LbGsGoToDashboard from '../Components/LeadBridge/LbGsGoToDashboard';
import LbEfWrapper from '../Components/LeadBridge/LbEachForm/LbEfWrapper';
import LbSupportSection from '../Components/LeadBridge/LbDashboard/LbSupportSection';
import ExpensesNavigator from '../Content/Expenses/ExpensesNavigator';
import ImHome from '../Content/InventoryManagement/ImHome'
import ImAddProducts from '../Content/InventoryManagement/ImAddProducts';
import ImBulkAddStock from '../Content/InventoryManagement/ImBulkAddStock';
import ImLanding from '../Content/InventoryManagement/ImLanding';
import MembershipHome from '../Content/Membership/MembershipHome';
import SellMembership from '../Content/Membership/SellMembership';
import SecuritySetting from '../Content/Settings/SecuritySetting';
import InvoiceSettings from '../Content/Settings/InvoiceSettings';
import UploadImage from '../Components/Communications/Assets/UploadImage';
import RegisterWhatsAppNumber from '../Components/Communications/Onboarding/RegisterWhatsAppNumber';
import SalonCreativeStudio from '../Components/Communications/CreativeStudio/SalonCreativeStudio';
import AddNewExpense from '../Content/Expenses/AddNewExpense';
import ExpensesHistory from '../Content/Expenses/ExpensesHistory';
import EachExpense from '../Content/Expenses/EachExpenseEditor';
import ExpensesReviewQueue from '../Content/Expenses/ExpensesReviewQueue';
import ExpenseReviewDetails from '../Content/Expenses/ExpenseReviewDetails';
import ExpensesSummary from '../Content/Expenses/ExpensesSummary';
import ExpensesLanding from '../Content/Expenses/ExpensesLanding';
import StaffAnalytics from '../Content/StaffManagement/StaffAnalytics';

import PayrollOverview from '../Content/Payroll/Overview/PayrollOverview';
import ScheduleADemo from '../Content/Payroll/ScheduleADemo';
import PayrollSetupScreen from '../Content/Payroll/PayrollSetupScreen';
import GeneratePayrollScreen from '../Content/Payroll/GeneratePayrollScreen';
import PayrollRunHistoryScreen from '../Content/Payroll/PayrollRunHistoryScreen';
import PayrollSimulatorScreen from '../Content/Payroll/PayrollSimulatorScreen';
import PayrollRunDetailScreen from '../Content/Payroll/PayrollRunDetailScreen';
import StaffPayslipDetailScreen from '../Content/Payroll/StaffPayslipDetailScreen';
import PayslipDeliveryStatusScreen from '../Content/Payroll/PayslipDeliveryStatusScreen';
import DisputeDetailScreen from '../Content/Payroll/DisputeDetailScreen';
import GenerateFnFScreen from '../Content/Payroll/GenerateFnFScreen';
import FnFHomeScreen from '../Content/Payroll/FnFHomeScreen';
import FnFSettlementDetailScreen from '../Content/Payroll/FnFSettlementDetailScreen';
import StoreStaffAssignmentOverviewScreen from '../Content/Payroll/StoreStaffAssignmentOverviewScreen';
import PayrollStaffReadinessScreen from '../Content/Payroll/PayrollStaffReadinessScreen';
import ComplianceConfigScreen from '../Content/Payroll/ComplianceConfigScreen';
import CycleConfigSetupScreen from '../Content/Payroll/CycleConfigSetupScreen';
import CycleConfigEditScreen from '../Content/Payroll/CycleConfigEditScreen';
import CycleConfigViewScreen from '../Content/Payroll/CycleConfigViewScreen';
import LeavePolicyListScreen from '../Content/Payroll/LeavePolicyListScreen';
import LeavePolicySetupScreen from '../Content/Payroll/LeavePolicySetupScreen';
import EditLeavePolicyScreen from '../Content/Payroll/EditLeavePolicyScreen';
import InitializeLeaveBalancesScreen from '../Content/Payroll/InitializeLeaveBalancesScreen';
import StaffLeaveCardScreen from '../Content/Payroll/StaffLeaveCardScreen';
import StoreLeaveBalanceSummaryScreen from '../Content/Payroll/StoreLeaveBalanceSummaryScreen';
import ManualLeaveAdjustmentScreen from '../Content/Payroll/ManualLeaveAdjustmentScreen';
import YearEndLeaveProcessScreen from '../Content/Payroll/YearEndLeaveProcessScreen';
import StoreAdvanceBookScreen from '../Content/Payroll/StoreAdvanceBookScreen';
import StaffAdvanceLedgerScreen from '../Content/Payroll/StaffAdvanceLedgerScreen';
import CreateAdvanceRequestScreen from '../Content/Payroll/CreateAdvanceRequestScreen';
import AdvanceApprovalScreen from '../Content/Payroll/AdvanceApprovalScreen';
import WriteOffAdvanceScreen from '../Content/Payroll/WriteOffAdvanceScreen';
import ForecloseAdvanceScreen from '../Content/Payroll/ForecloseAdvanceScreen';
import RescheduleAdvanceScreen from '../Content/Payroll/RescheduleAdvanceScreen';
import HolidayMasterScreen from '../Content/Payroll/HolidayMasterScreen'
import CreateSalonHolidayScreen from '../Content/Payroll/CreateSalonHolidayScreen';
import CreateSalaryStructureScreen from '../Content/Payroll/CreateSalaryStructureScreen';
import SalaryStructureScreen from '../Content/Payroll/SalaryStructureScreen';
import SalaryStructureDetailScreen from '../Content/Payroll/SalaryStructureDetailScreen';
import AddComponentScreen from '../Content/Payroll/AddComponentScreen';
import ReviseComponentScreen from '../Content/Payroll/ReviseComponentScreen';
import DuplicateTemplateScreen from '../Content/Payroll/DuplicateTemplateScreen';
import AssignSalaryStructureScreen from '../Content/Payroll/AssignSalaryStructureScreen';
import BulkSalaryAssignmentScreen from '../Content/Payroll/BulkSalaryAssignmentScreen';
import ReviseStaffSalaryScreen from '../Content/Payroll/ReviseStaffSalaryScreen';
import AssignIncentivePlanScreen from '../Content/Payroll/AssignIncentivePlanScreen';
import StaffCompensationProfileScreen from '../Content/Payroll/StaffCompensationProfileScreen';
import IncentiveStructureScreen from '../Content/Payroll/IncentiveStructureScreen';
import CreateIncentiveTemplateScreen from '../Content/Payroll/CreateIncentiveTemplateScreen';
import IncentiveTemplateDetailScreen from '../Content/Payroll/IncentiveTemplateDetailScreen';
import AddIncentiveComponentScreen from '../Content/Payroll/AddIncentiveComponentScreen';
import ReviseIncentiveComponentScreen from '../Content/Payroll/ReviseIncentiveComponentScreen';
import DuplicateIncentiveTemplateScreen from '../Content/Payroll/DuplicateIncentiveTemplateScreen';
import KnowledgeBankScreen from '../Content/Payroll/KnowledgeBank/KnowledgeBankScreen';
import KBSectionScreen from '../Content/Payroll/KnowledgeBank/KBSectionScreen';
import MunimIntroScreen from '../Content/Payroll/KnowledgeBank/MunimIntroScreen';
import RegenerateEmbeddings from '../Content/Payroll/KnowledgeBank/RegenerateEmbeddings';




// =============================================================
// MICROSITE — Import Block
// Add these imports at the top of MainNavigator.js
// alongside your other screen imports
// =============================================================
 
import MicrositeShell            from '../Content/Microsite/MicrositeShell/MicrositeShell';
import MicrositeDashboard        from '../Content/Microsite/MicrositeDashboard/MicrositeDashboard';
import MicrositeGeneral          from '../Content/Microsite/MicrositeGeneral/MicrositeGeneral';
import MicrositeTheme            from '../Content/Microsite/MicrositeTheme/MicrositeTheme';
import MicrositeNavigation       from '../Content/Microsite/MicrositeNavigation/MicrositeNavigation';
import MicrositeSocial           from '../Content/Microsite/MicrositeSocial/MicrositeSocial';
import MicrositeLanding          from '../Content/Microsite/MicrositeLanding/MicrositeLanding';
import MicrositeLandingSection   from '../Content/Microsite/MicrositeLandingSection/MicrositeLandingSection';
import MicrositeIntegrations     from '../Content/Microsite/MicrositeIntegrations/MicrositeIntegrations';
import MicrositePlan             from '../Content/Microsite/MicrositePlan/MicrositePlan';
import MicrositeSeo              from '../Content/Microsite/MicrositeSeo/MicrositeSeo';
import MicrositeSeoPages         from '../Content/Microsite/MicrositeSeoPages/MicrositeSeoPages';
import MicrositeSeoPageEditor    from '../Content/Microsite/MicrositeSeoPageEditor/MicrositeSeoPageEditor';
import MicrositeRedirects        from '../Content/Microsite/MicrositeRedirects/MicrositeRedirects';
import MicrositeSitemap          from '../Content/Microsite/MicrositeSitemap/MicrositeSitemap';
import MicrositeCustomPages      from '../Content/Microsite/MicrositeCustomPages/MicrositeCustomPages';
import MicrositeCustomPageEditor from '../Content/Microsite/MicrositeCustomPageEditor/MicrositeCustomPageEditor';
import MicrositeBlog             from '../Content/Microsite/MicrositeBlog/MicrositeBlog';
import MicrositeBlogEditor       from '../Content/Microsite/MicrositeBlogEditor/MicrositeBlogEditor';
import MicrositePopups           from '../Content/Microsite/MicrositePopups/MicrositePopups';
import MicrositePopupEditor      from '../Content/Microsite/MicrositePopupEditor/MicrositePopupEditor';
import MicrositeAnnouncements    from '../Content/Microsite/MicrositeAnnouncements/MicrositeAnnouncements';
import MicrositeAnalytics        from '../Content/Microsite/MicrositeAnalytics/MicrositeAnalytics';
import MicrositeConversions      from '../Content/Microsite/MicrositeConversions/MicrositeConversions';
import MicrositeTracking         from '../Content/Microsite/MicrositeTracking/MicrositeTracking';
import MicrositeDomains          from '../Content/Microsite/MicrositeDomains/MicrositeDomains';
import MicrositePublish          from '../Content/Microsite/MicrositePublish/MicrositePublish';
import MicrositeEmailTemplates   from '../Content/Microsite/MicrositeEmailTemplates/MicrositeEmailTemplates';
import MicrositeEmailTemplateEditor from '../Content/Microsite/MicrositeEmailTemplateEditor/MicrositeEmailTemplateEditor';
import MicrositeVersionHistory   from '../Content/Microsite/MicrositeVersionHistory/MicrositeVersionHistory';
import ComConfigShell from '../Content/Settings/CommunicationConfigurations/ComConfigShell/ComConfigShell';
import ComConfigDashboard from '../Content/Settings/CommunicationConfigurations/ComConfigDashboard';
import ComConfigEventPolicy from '../Content/Settings/CommunicationConfigurations/ComConfigEventPolicy';
import ComConfigTemplateSelection from '../Content/Settings/CommunicationConfigurations/ComConfigTemplateSelection';
import ComConfigResolutionPreview from '../Content/Settings/CommunicationConfigurations/ComConfigResolutionPreview';
import ComConfigSenderConnections from '../Content/Settings/CommunicationConfigurations/ComConfigSenderConnections';
import ComConfigMyTemplates from '../Content/Settings/CommunicationConfigurations/ComConfigMyTemplates';

// =============================================================
// SPECIAL MOMENTS — Import Block
// CSMShell wraps all /special-moments/* routes via <Outlet />
// =============================================================
import CSMShell from '../Content/SpecialMoments/CSMShell';
import CSMDashboard from '../Content/SpecialMoments/CSMDashboard';
import CSMCelebrationInbox from '../Content/SpecialMoments/CSMCelebrationInbox';
import CSMCalendar from '../Content/SpecialMoments/CSMCalendar';
import CSMCustomerProfile from '../Content/SpecialMoments/CSMCustomerProfile';
import CSMWishComposer from '../Content/SpecialMoments/CSMWishComposer';
import CSMHistory from '../Content/SpecialMoments/CSMHistory';
import CSMTemplates from '../Content/SpecialMoments/CSMTemplates';
import CSMSettings from '../Content/SpecialMoments/CSMSettings';
import CSMAnalytics from '../Content/SpecialMoments/CSMAnalytics';





const MainNavigator = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const menuToggler = () => setIsMenuOpen(!isMenuOpen)
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const accessibilityData = JSON.parse(authCtx?.loginData)?.accessibilityData
    // console.log(JSON.parse(authCtx?.loginData))


    const location = useLocation()

    useEffect(() => {
        trackEvent('page_viewed', {
            path: location.pathname,
        });
    }, [location.pathname]);

    const pathsToHideHeader = [
        "/invoice/create",
        "/invoice/preview",
        "/config/membership-card",
        "/calendar",
        "/staff",
        "/settings/store/primary-details",
        "/communications/campaign/:campaignIdentifier/:currentStep",
        "settings/expenses",
        "leadbridge/get-started",
        "leadbridge/dashboard",
        "leadbridge/help",
        "settings/account",
        "settings/security",
        "settings/invoice",
        "manage/price-list",
        "manage/price-list-new",
        "manage/employees",
        "bookings",
        "manage-stores",
        "manage/clients",
        "feedbacks",
        "config/daily-reports",
        // Add more specific paths as needed
    ];

    const initialPathsToHideHeader = [
        "/communications",
        "/leadbridge/view-token",
        "/leadbridge/forms",
        "/expenses",
        "/config/memberships/",
        "/manage/inventory",
        "/memberships/",
        "/membership/",
        "/manage-access/",
        "/store/employee/",
        "/store/employee/",
        "/payroll",
        "/reports/daily",
        "/microsite",
        "/special-moments",
        "/communication-settings",
        "/booking"
    ];

    const shouldHideHeader = pathsToHideHeader.some((path) => location.pathname.includes(path)) ||
        initialPathsToHideHeader.some((initialPath) => location.pathname.startsWith(initialPath));



    if (!authCtx.isLoggedIn) {
        return (
            <div className={styles.mainWrapper}>
                <NetworkStatus />
                <ToastContainer />

                <Routes>
                    <Route path="*" element={<Login />}></Route>
                    <Route path="/" element={<Login />}></Route>
                    <Route path="/ur/:pageKey" element={<CofAlpha />}></Route>

                    {/* introducing on th nov 2024 */}
                    <Route path="/promos/:promoIdentifier" element={<ViewPromo />}></Route>
                </Routes>
            </div>
        )
    } else {
        return (
            <div className={styles.mainWrapper}>
                <NetworkStatus />
                <ToastContainer />
                <div className={isMenuOpen !== true ? styles.open : styles.close}>
                    <LeftMenu isOpen={isMenuOpen} toggler={menuToggler} />
                </div>
                <div className={styles.rightCol}>
                    {!shouldHideHeader && (
                        <div className={styles.upperHeaderWrapper}>
                            <UpperHeader />
                        </div>
                    )}
                    <Routes>
                        <Route path="*" element={<NotFound />}></Route>
                        {/* <Route path="/" element={<Home />}></Route> */}
                        <Route path="/" element={<Overview />}></Route>
                        {/* <Route path="/ur/:pageKey" element={<CofAlpha />}></Route> */}
                        {accessibilityData?.includes("/overview") && <Route path="/overview" element={<Overview />}></Route>}
                        {accessibilityData?.includes("/manage-stores") && <Route path="/manage-stores" element={<AllStores />}></Route>}
                        {accessibilityData?.includes("/manage/details") && <Route path="/manage/details" element={<StoreDetails />}></Route>}
                        {accessibilityData?.includes("/manage/employees") && <Route path="/manage/employees" element={<StoreEmployees />}></Route>}
                        {accessibilityData?.includes("/manage/price-list") && <Route path="/manage/price-list" element={<StorePriceList />}></Route>}

                        {accessibilityData?.includes("/manage/price-list") && <Route path="/manage/price-list-new" element={<StorePriceListBulkAction />}></Route>}
                        {/* <Route path="/manage/price-list/update-item/:serviceIdentifier" element={<UpdateService />}></Route> */}
                        <Route path="/manage/price-list/update-item/:serviceIdentifier" element={<StorePriceList />}></Route>

                        {accessibilityData?.includes("/manage/clients") && <Route path="/manage/clients" element={<StoreClients />}></Route>}
                        {accessibilityData?.includes("/services") && <Route path="/services" element={<ManageServices />}></Route>}
                        {accessibilityData?.includes("/users") && <Route path="/users" element={<Users />}></Route>}
                        <Route path="/users" element={<Users />}></Route>
                        <Route path="/user/:clientIdentifier" element={<EachUserWrapper />}></Route>
                        <Route path="/user/:clientIdentifier/:activeTab" element={<EachUserWrapper />}></Route>
                        {accessibilityData?.includes("/user/:clientIdentifier") && <Route path="/user/:clientIdentifier" element={<EachUserWrapper />}></Route>}

                        <Route path="/memberships" element={<AllMembers />}></Route>
                        <Route path="/memberships/sell" element={<AddNewMember />}></Route>
                        {accessibilityData?.includes("/memberships") && <Route path="/memberships" element={<AllMembers />}></Route>}
                        {accessibilityData?.includes("/memberships/sell") && <Route path="/memberships/sell" element={<AddNewMember />}></Route>}
                        {accessibilityData?.includes("/invoices") && <Route path="/invoices" element={<AllInvoices />}></Route>}
                        {accessibilityData?.includes("/invoice/:invoiceIdentifier") && <Route path="/invoice/:invoiceIdentifier" element={<AllInvoices />}></Route>}
                        {/* {accessibilityData?.includes("/reports") && <Route path="/reports" element={<AllInvoices />}></Route>}
                        {accessibilityData?.includes("/reports/:invoiceIdentifier") && <Route path="/reports/:invoiceIdentifier" element={<AllInvoices />}></Route>} */}



                        <Route path="/membership/:purchaseCardIdentifier" element={<CardDetails />}></Route>
                        <Route path="/bookings" element={<CurrentSessions />}></Route>
                        <Route path="/booking/:bookingIdentifier" element={<BookingDetails />}></Route>
                        {accessibilityData?.includes("/sessions") && <Route path="/sessions" element={<ActiveSessions />}></Route>}
                        {accessibilityData?.includes("/sessions/:sessionIdentifier") && <Route path="/sessions/:sessionIdentifier" element={<ActiveSessions />}></Route>}
                        <Route path="/feedbacks" element={<FeedbackHome />}></Route>
                        <Route path="/feedbacks/settings" element={<FeedbackSettings />}></Route>
                        <Route path="/ledger" element={<Ledger />}></Route>
                        <Route path="/staff" element={<ManageStaff />}></Route>
                        <Route path="/staff/:staffIdentifier" element={<ManageStaff />}></Route>
                        <Route path="/staff/:staffIdentifier/:activeTab" element={<ManageStaff />}></Route>


                        <Route path="/analytics" element={<MonthlyRevenue />}></Route>
                        <Route path="/analytics/staff" element={<StaffAnalytics />}></Route>

                        {accessibilityData?.includes("/add-clients") && <Route path="/add-clients" element={<AddClients />}></Route>}
                        {/* {accessibilityData?.includes("/calendar") && <Route path="/calendar" element={<EventCalendar />}></Route>} */}
                        {accessibilityData?.includes("/calendar") && <Route path="/calendar" element={<StaffAppointmentCalendar />}></Route>}

                        {accessibilityData?.includes("/store/employee/:employeeIdentifier") && <Route path="/store/employee/:employeeIdentifier" element={<ManageEachEmployee />}></Route>}
                        {accessibilityData?.includes("/manage-access/:authIdentifier") && <Route path="/manage-access/:authIdentifier" element={<ManageAccess />}></Route>}

                        {/* {accessibilityData?.includes("/user-registration-forms") && <Route path="/user-registration-forms" element={<ManageUserRegistrationPages />}></Route>} */}
                        <Route path="/user-registration-forms" element={<ManageUserRegistrationPages />}></Route>



                        <Route
                            path="/expenses"
                            element={
                                <>
                                    <ExpensesLanding />
                                </>
                            }
                        ></Route>
                        <Route path="/collection-reports" element={<CollectionReport />}></Route>

                        <Route path="/expenses-report" element={<ExpensesReport />}></Route>
                        <Route path="/outstanding-report" element={<OutstandingReport />}></Route>

                        {/* <Route path="/manage-refers" element={<CollectionReport />}></Route> */}



                        {/* <Route path="/music" element={<MusicPlayer />}></Route> */}
                        {/* <Route component={MusicPlayer} ></Route> */}

                        {/* adding this on 20th November 2024 */}
                        <Route path="/settings/pricelist" element={<PriceListSettings />}></Route>

                        {/* introducing on 2nd nov 2024 */}
                        <Route path="/communications/send" element={<SendPromo />}></Route>

                        {/* introducing on 1st January 2025 */}
                        <Route path="/communications" element={<ComHome />}></Route>
                        <Route path="/communications/create-campaign/:campaignIdentifier" element={<ComCreateCampaigns />}></Route>
                        <Route path="/communications/all-campaigns" element={<ComAllCampaigns />}></Route>
                        <Route path="/communications/campaign/:campaignIdentifier" element={<ComAllCampaigns />}></Route>
                        <Route path="/communications/campaign/:campaignIdentifier/:currentStep" element={<ComCreateCampaigns />}></Route>

                        <Route path="/communications/campaign/:campaignIdentifier/:currentStep/:paymentStatus/:txnId" element={<ComCreateCampaigns />}></Route>


                        <Route path="/communications/audience/all-audiences" element={<ComAllAudiences />}></Route>
                        <Route path="/communications/audience/create-new" element={<CreateAudience />}></Route>



                        {/* introducing it on 10th Jan 2025 */}
                        <Route path="/invoice/create" element={<GIInterfaceAlpha />}></Route>
                        <Route path="/invoice/create/:sessionIdentifier" element={<GIInterfaceAlpha />}></Route>
                        <Route path="/invoice/preview/:sessionIdentifier" element={<InvoicePreviewer />}></Route>


                        {/* introducing it on 19th Jan 2025 */}
                        <Route path="/clients/bulk-upload" element={<UploadClientDataInBulk />}></Route>


                        {/* introducing it on 28th Feb 2025 */}
                        <Route path="/settings/set-up" element={<AccountSetup />}></Route>
                        <Route path="/settings/store/primary-details" element={<StorePrimaryDetails />}></Route>

                        {/* introducing it on 29th Mar 2025 */}
                        <Route path="/settings/account" element={<AccountSetting />}></Route>
                        <Route path="/settings/security" element={<SecuritySetting />}></Route>

                        {/* introducing it on 29th Mar 2025 */}
                        {accessibilityData?.includes("/config/daily-reports") && <Route path="/config/daily-reports" element={<DailyReportsConfiguration />}></Route>}
                        {accessibilityData?.includes("/config/daily-reports") && <Route path="/reports/daily" element={<DRDashboard />}></Route>}
                        {accessibilityData?.includes("/config/daily-reports") && <Route path="/reports/daily/settings" element={<DRSettings />}></Route>}
                        {accessibilityData?.includes("/config/daily-reports") && <Route path="/reports/daily/history" element={<DRHistory />}></Route>}

                        {/* introducing it on 6th May 2025 */}
                        {/* {accessibilityData?.includes("/settings/expenses") && <Route path="/settings/expenses" element={<ExpenseSetting />}></Route>} */}
                        <Route
                            path="/settings/expenses"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <ExpenseSetting />
                                </>
                            }
                        ></Route>

                        {/* introducing it on 10th August 2025 */}

                        {/* <Route path="/expenses/:activeIdentifier" element={<ExpenseSetting />}></Route> */}


                        {/* introducing it on 5th July 2025 */}
                        <Route path="/leadbridge" element={<LbHome />}></Route>
                        <Route path="/leadbridge/get-started" element={<LbGsHero />}></Route>
                        <Route path="/leadbridge/get-started/:step" element={<LbGetStarted />}></Route>
                        <Route path="/leadbridge/dashboard" element={<LbDashboard />}></Route>
                        <Route path="/leadbridge/view-token/:token" element={<LbGsGoToDashboard />}></Route>
                        <Route path="/leadbridge/forms/:formIdentifier" element={<LbEfWrapper />}></Route>

                        <Route path="/leadbridge/help" element={<LbSupportSection />}></Route>


                        {/* introducing it on 16th August 2025 */}
                        <Route path="/manage/inventory" element={<ImLanding />}></Route>
                        <Route path="/manage/inventory/products" element={<ImHome />}></Route>
                        <Route path="/manage/inventory/add-products" element={<ImAddProducts />}></Route>
                        <Route path="/manage/inventory/add-stock" element={<ImBulkAddStock />}></Route>


                        {/* introducing it on 23rd August 2025 */}

                        <Route path="/memberships/:pageIdentifier" element={<MembershipHome />}></Route>
                        <Route path="/memberships/settings/:membershipIdentifier/:activeTab" element={<MembershipHome />}></Route>
                        <Route path="/memberships/sell-membership" element={<SellMembership />}></Route>


                        {/* introducing it on 24th September 2025 */}
                        <Route path="/settings/invoice" element={<InvoiceSettings />}></Route>

                        {/* <Route path="/config/memberships/:cardIdentifier/:activeTab" element={<ConfigMembershipCards />}></Route> */}

                        <Route path="/communications/upload-image" element={<UploadImage />}></Route>



                        <Route path="/communications/register-whatsapp-number" element={<RegisterWhatsAppNumber />}></Route>
                        <Route path="/communications/creative-studio" element={<SalonCreativeStudio />}></Route>


                        <Route
                            path="/expenses/landing"
                            element={
                                <>
                                    <ExpensesLanding />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/summary"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <ExpensesSummary />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/add"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <AddNewExpense />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/review"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <ExpensesReviewQueue />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/review/:expenseIdentifier"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <ExpenseReviewDetails />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/history"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <ExpensesHistory />
                                </>
                            }
                        ></Route>
                        <Route
                            path="/expenses/history/:expenseIdentifier"
                            element={
                                <>
                                    <ExpensesNavigator />
                                    <EachExpense />
                                </>
                            }
                        ></Route>


                        <Route path="/payroll/overview" element={<PayrollOverview />}></Route>
                        <Route path="/payroll/schedule-demo" element={<ScheduleADemo />}></Route>
                        <Route path="/payroll/setup" element={<PayrollSetupScreen />}></Route>
                        <Route path="/payroll/run-history" element={<PayrollRunHistoryScreen />}></Route>
                        <Route path="/payroll/simulator" element={<PayrollSimulatorScreen />}></Route>
                        <Route path="/payroll/staff-assignments" element={<StoreStaffAssignmentOverviewScreen />}></Route>
                        <Route path="/payroll/staff-readiness" element={<PayrollStaffReadinessScreen />}></Route>
                        <Route path="/payroll/setup/compliance-config" element={<ComplianceConfigScreen />}></Route>
                        <Route path="/payroll/run" element={<GeneratePayrollScreen />}></Route>
                        <Route path="/payroll/run/:runIdentifier" element={<PayrollRunDetailScreen />}></Route>
                        <Route path="/payroll/run/:runIdentifier/payslip/:staffIdentifier" element={<StaffPayslipDetailScreen />}></Route>
                        <Route path="/payroll/run/:runIdentifier/delivery-status" element={<PayslipDeliveryStatusScreen />}></Route>
                        <Route path="/payroll/dispute/:disputeIdentifier" element={<DisputeDetailScreen />}></Route>
                        <Route path="/payroll/fnf" element={<FnFHomeScreen />}></Route>
                        <Route path="/payroll/fnf/:staffIdentifier" element={<GenerateFnFScreen />}></Route>
                        <Route path="/payroll/fnf/:staffIdentifier/settlement/:settlementIdentifier" element={<FnFSettlementDetailScreen />}></Route>
                        <Route path="/payroll/ask-munim-ji" element={<KnowledgeBankScreen />}></Route>
                        <Route path="/payroll/ask-munim-ji/intro" element={<MunimIntroScreen />}></Route>
                        <Route path="/kb/section/:sectionIdentifier" element={<KBSectionScreen />}></Route>
                        <Route path="/payroll/setup/cycle-config" element={<CycleConfigSetupScreen />}></Route>
                        <Route path="/payroll/setup/cycle-config/view" element={<CycleConfigViewScreen />}></Route>
                        <Route path="/payroll/setup/cycle-config/edit" element={<CycleConfigEditScreen />}></Route>
                        <Route path="/payroll/setup/leave-policy" element={<LeavePolicyListScreen />}></Route>
                        <Route path="/payroll/setup/leave-policy/setup" element={<LeavePolicySetupScreen />}></Route>
                        <Route path="/payroll/setup/leave-policy/edit" element={<EditLeavePolicyScreen />}></Route>
                        <Route path="/payroll/setup/leave-balance-init" element={<InitializeLeaveBalancesScreen />}></Route>
                        <Route path="/payroll/leave-balance-overview" element={<StoreLeaveBalanceSummaryScreen />}></Route>
                        <Route path="/payroll/staff-leave-card/:staffIdentifier" element={<StaffLeaveCardScreen />}></Route>
                        <Route path="/payroll/manual-leave-adjustment/:staffIdentifier" element={<ManualLeaveAdjustmentScreen />}></Route>
                        <Route path="/payroll/year-end-leave-process" element={<YearEndLeaveProcessScreen />}></Route>
                        <Route path="/payroll/advance-book" element={<StoreAdvanceBookScreen />}></Route>
                        <Route path="/payroll/advance/staff-ledger/:staffIdentifier" element={<StaffAdvanceLedgerScreen />}></Route>
                        <Route path="/payroll/advance/:staffIdentifier/create" element={<CreateAdvanceRequestScreen />}></Route>
                        <Route path="/payroll/advance/:advanceIdentifier/approve" element={<AdvanceApprovalScreen />}></Route>
                        <Route path="/payroll/advance/:advanceIdentifier/write-off" element={<WriteOffAdvanceScreen />}></Route>
                        <Route path="/payroll/advance/:advanceIdentifier/foreclose" element={<ForecloseAdvanceScreen />}></Route>
                        <Route path="/payroll/advance/:advanceIdentifier/reschedule" element={<RescheduleAdvanceScreen />}></Route>
                        <Route path="/payroll/setup/holiday-master" element={<HolidayMasterScreen />}></Route>
                        <Route path="/payroll/setup/holiday-master/create" element={<CreateSalonHolidayScreen />}></Route>
                        <Route path="/payroll/setup/incentive-structure" element={<IncentiveStructureScreen />}></Route>
                        <Route path="/payroll/setup/incentive-structure/create" element={<CreateIncentiveTemplateScreen />}></Route>
                        <Route path="/payroll/incentive-structure/:templateIdentifier" element={<IncentiveTemplateDetailScreen />}></Route>
                        <Route path="/payroll/incentive-structure/:templateIdentifier/add-component" element={<AddIncentiveComponentScreen />}></Route>
                        <Route path="/payroll/incentive-structure/:templateIdentifier/edit-component/:componentIdentifier" element={<ReviseIncentiveComponentScreen />}></Route>
                        <Route path="/payroll/incentive-structure/:templateIdentifier/duplicate" element={<DuplicateIncentiveTemplateScreen />}></Route>
                        <Route path="/payroll/salary-structure/create" element={<CreateSalaryStructureScreen />}></Route>
                        <Route path="/payroll/salary-structure" element={<SalaryStructureScreen />}></Route>
                        <Route path="/payroll/salary-structure/:templateIdentifier" element={<SalaryStructureDetailScreen />}></Route>
                        <Route path="/payroll/salary-structure/:templateIdentifier/add-component" element={<AddComponentScreen />}></Route>
                        <Route path="/payroll/salary-structure/:templateIdentifier/edit-component/:componentIdentifier" element={<ReviseComponentScreen />}></Route>
                        <Route path="/payroll/salary-structure/:templateIdentifier/duplicate" element={<DuplicateTemplateScreen />}></Route>
                        <Route path="/payroll/assign-salary-structure" element={<AssignSalaryStructureScreen />}></Route>
                        <Route path="/payroll/bulk-assign-salary" element={<BulkSalaryAssignmentScreen />}></Route>
                        <Route path="/payroll/revise-salary" element={<ReviseStaffSalaryScreen />}></Route>
                        <Route path="/payroll/assign-incentive-plan" element={<AssignIncentivePlanScreen />}></Route>
                        <Route path="/payroll/staff-compensation/:staffIdentifier" element={<StaffCompensationProfileScreen />}></Route>


                        <Route path="/payroll/admin/settings/regenerate-embeddings" element={<RegenerateEmbeddings />}></Route>


 
                        {/* // =============================================================
                        // MICROSITE — Route Block
                        // Add these routes inside your <Routes> block in MainNavigator.js
                        // MicrositeShell wraps all /microsite/* routes via <Outlet />
                        // so its nested routes inherit the shell layout automatically
                        // =============================================================
                        */}

                        <Route path="/microsite" element={<MicrositeShell />}>
                            <Route index element={<MicrositeDashboard />} />
                            <Route path="general" element={<MicrositeGeneral />} />
                            <Route path="theme" element={<MicrositeTheme />} />
                            <Route path="navigation" element={<MicrositeNavigation />} />
                            <Route path="social" element={<MicrositeSocial />} />
                            <Route path="landing" element={<MicrositeLanding />} />
                            <Route path="landing/:sectionKey" element={<MicrositeLandingSection />} />
                            <Route path="integrations" element={<MicrositeIntegrations />} />
                            <Route path="plan" element={<MicrositePlan />} />
                            <Route path="seo" element={<MicrositeSeo />} />
                            <Route path="seo/pages" element={<MicrositeSeoPages />} />
                            <Route path="seo/pages/new" element={<MicrositeSeoPageEditor />} />
                            <Route path="seo/pages/:id/edit" element={<MicrositeSeoPageEditor />} />
                            <Route path="seo/redirects" element={<MicrositeRedirects />} />
                            <Route path="seo/sitemap" element={<MicrositeSitemap />} />
                            <Route path="pages" element={<MicrositeCustomPages />} />
                            <Route path="pages/new" element={<MicrositeCustomPageEditor />} />
                            <Route path="pages/:id/edit" element={<MicrositeCustomPageEditor />} />
                            <Route path="blog" element={<MicrositeBlog />} />
                            <Route path="blog/new" element={<MicrositeBlogEditor />} />
                            <Route path="blog/:id/edit" element={<MicrositeBlogEditor />} />
                            <Route path="popups" element={<MicrositePopups />} />
                            <Route path="popups/new" element={<MicrositePopupEditor />} />
                            <Route path="popups/:id/edit" element={<MicrositePopupEditor />} />
                            <Route path="announcements" element={<MicrositeAnnouncements />} />
                            <Route path="analytics" element={<MicrositeAnalytics />} />
                            <Route path="analytics/conversions" element={<MicrositeConversions />} />
                            <Route path="tracking" element={<MicrositeTracking />} />
                            <Route path="domains" element={<MicrositeDomains />} />
                            <Route path="publish" element={<MicrositePublish />} />
                            <Route path="email-templates" element={<MicrositeEmailTemplates />} />
                            <Route path="email-templates/:id/edit" element={<MicrositeEmailTemplateEditor />} />
                            <Route path="versions/:tabKey" element={<MicrositeVersionHistory />} />
                        </Route>


                        {/* introducing it on 18th July 2026 — Special Moments */}
                        <Route path="/special-moments" element={<CSMShell />}>
                            <Route index element={<CSMDashboard />} />
                            <Route path="inbox" element={<CSMCelebrationInbox />} />
                            <Route path="calendar" element={<CSMCalendar />} />
                            <Route path="customer/:customerIdentifier" element={<CSMCustomerProfile />} />
                            <Route path="wish/:customerIdentifier/:occasionId" element={<CSMWishComposer />} />
                            <Route path="history" element={<CSMHistory />} />
                            <Route path="templates" element={<CSMTemplates />} />
                            <Route path="settings" element={<CSMSettings />} />
                            <Route path="insights" element={<CSMAnalytics />} />
                        </Route>

                        <Route path="/communication-settings" element={<ComConfigShell />}>
                            <Route index element={<ComConfigDashboard />} />
                            <Route path=":eventId" element={<ComConfigEventPolicy />} />
                            <Route path=":eventId/templates/:channelId/:recipientTypeId" element={<ComConfigTemplateSelection />} />
                            <Route path=":eventId/preview/:recipientTypeId" element={<ComConfigResolutionPreview />} />
                            <Route path="sender-connections" element={<ComConfigSenderConnections />} />
                            <Route path="my-templates" element={<ComConfigMyTemplates />} />
                        </Route>

                    </Routes>
                </div>
            </div>
        )
    }

}

export default MainNavigator